{
  "versi": 1,
  "mapel": "bahasa-indonesia",
  "keterangan": "Soal pengembangan Teks Fiksi: lima teks orisinal (cerpen, fabel, puisi) dengan alasan setiap pilihan dan bukti dari teks.",
  "bacaan": [
    {
      "id": "pf-tongkat-estafet",
      "jenis": "Teks Fiksi",
      "judul": "Tongkat Estafet yang Terjatuh",
      "teks": "Pagi itu lapangan sekolah ramai sekali. Kelas 6A dan 6B akan bertanding lari estafet dalam lomba antarkelas. Tim 6B terdiri atas empat pelari: Lestari, Bayu, Tiara, dan Raka. Raka adalah pelari tercepat di kelas, dan ia yakin timnya pasti menang.\n\nSelama seminggu, Raka berlatih lari sendirian setiap sore. Teman-temannya beberapa kali mengajaknya berlatih memberikan tongkat estafet bersama, tetapi Raka selalu menolak. “Yang penting larinya cepat. Memberi tongkat itu gampang,” katanya.\n\nSaat lomba dimulai, Lestari berlari paling awal dan memberikan tongkat kepada Bayu dengan lancar. Bayu lalu menyerahkannya kepada Tiara. Tiara berlari sekuat tenaga menuju Raka. Namun, Raka sudah berlari terlalu cepat sebelum tongkat sampai di tangannya. Tongkat itu terlepas dan jatuh ke tanah. Ketika Raka berbalik untuk mengambilnya, pelari 6A melesat mendahuluinya.\n\nTim 6B kalah. Raka menendang rumput dengan kesal. “Ini gara-gara Tiara!” serunya. Tiara menunduk dan matanya berkaca-kaca.\n\nPak Darto, guru olahraga mereka, menepuk bahu Raka. “Raka, estafet itu lomba tim. Secepat apa pun kamu berlari, tongkatnya harus berpindah dengan baik. Siapa yang tidak mau berlatih memberi tongkat bersama?” Raka terdiam. Ia teringat ajakan teman-temannya yang selalu ia tolak.\n\nRaka pun menghampiri Tiara. “Maaf, Tiara. Aku yang salah karena tidak mau berlatih bersama kalian,” katanya. Tiara tersenyum dan mengangguk. Setelah itu, mereka berempat mendatangi tim 6A untuk memberi selamat. Sejak hari itu, tim 6B selalu berlatih bersama setiap sore."
    },
    {
      "id": "pf-surat-opung",
      "jenis": "Teks Fiksi",
      "judul": "Surat dari Jakarta",
      "teks": "Hari Minggu siang, rumah Tigor di Pematangsiantar terasa sepi. Ayah sedang bekerja, sedangkan Ibu harus pergi ke pasar. Sebelum berangkat, Ibu berpesan, “Tigor, temani Opung di rumah, ya. Kalau Opung butuh sesuatu, bantu beliau.” Tigor mengangguk, walaupun sebenarnya ia sudah berjanji bermain bola dengan teman-temannya.\n\nTidak lama kemudian, terdengar suara Ucok memanggil dari depan pagar. “Tigor! Ayo, kita kurang satu pemain!” Tigor bimbang. Ia melirik Opung yang sedang duduk di kursi rotan sambil memegang sepucuk surat.\n\n“Pergilah kalau mau bermain,” kata Opung pelan. “Opung hanya ingin membaca surat dari kakakmu, Rosa, di Jakarta. Tapi kacamata Opung patah tadi pagi.” Opung tersenyum, tetapi Tigor melihat wajah Opung tampak sedih.\n\nTigor berjalan ke pagar. “Cok, maaf, hari ini aku tidak bisa ikut. Aku sudah janji kepada Ibu untuk menemani Opung,” katanya. Ucok mengangguk dan berlari kembali ke lapangan.\n\nTigor lalu duduk di samping Opung dan membacakan surat itu dengan suara keras dan jelas. Dalam suratnya, Rosa bercerita tentang sekolahnya dan menulis bahwa ia rindu masakan Opung. Opung tertawa kecil, lalu matanya basah. “Terima kasih, Tigor. Kau cucu yang baik,” ucapnya sambil mengusap kepala Tigor.\n\nSore harinya, Ibu pulang dan mendengar cerita Opung. Ibu memeluk Tigor dengan bangga. Malam itu, Tigor membantu Opung menulis surat balasan untuk Rosa. Tigor merasa hari itu lebih menyenangkan daripada pertandingan bola mana pun."
    },
    {
      "id": "pf-liang-landak",
      "jenis": "Teks Fiksi",
      "judul": "Tupai Cici dan Landak Lomo",
      "teks": "Di tepi Hutan Bambu hiduplah seekor tupai bernama Cici. Cici sangat lincah. Ia dapat melompat dari satu dahan ke dahan lain secepat angin. Sayangnya, Cici suka menyombongkan diri dan mengejek hewan lain yang tidak secepat dirinya.\n\nSuatu pagi, Cici melihat Lomo, seekor landak, berjalan pelan mencari umbi-umbian. “Hai, Lomo! Jalanmu lambat sekali. Durimu juga hanya membuat hewan lain takut mendekat. Apa gunanya punya tubuh seperti itu?” ejek Cici sambil tertawa. Lomo tidak membalas. Ia hanya tersenyum dan melanjutkan perjalanannya.\n\nBeberapa hari kemudian, langit menjadi gelap. Angin bertiup sangat kencang dan hujan turun deras sepanjang malam. Pohon tempat Cici bersarang patah dan roboh. Cici terlempar ke tanah dengan kaki terkilir. Tubuhnya basah kuyup dan menggigil kedinginan.\n\nDalam gelap, Cici mendengar suara pelan. “Cici, masuklah ke liangku. Di dalam tanah lebih hangat dan kering,” kata Lomo. Cici terkejut. Ia teringat ejekannya kepada Lomo beberapa hari sebelumnya.\n\nCici pun masuk ke liang Lomo yang hangat. Malam itu, seekor musang lapar mengendus-endus di depan liang. Lomo segera menegakkan duri-durinya di mulut liang. Musang itu tertusuk duri dan lari ketakutan.\n\nKeesokan paginya, hujan berhenti. Cici menunduk malu. “Lomo, maafkan aku. Dulu aku mengejek durimu, padahal durimu yang menyelamatkan kita,” katanya. Lomo tertawa kecil. “Setiap makhluk punya kelebihan masing-masing, Cici.” Sejak saat itu, Cici tidak pernah lagi mengejek hewan lain."
    },
    {
      "id": "pf-lagu-dari-timur",
      "jenis": "Teks Fiksi",
      "judul": "Lagu dari Timur",
      "teks": "Hari Senin, Bu Ratna masuk ke kelas 6C bersama seorang anak perempuan berambut keriting. “Anak-anak, ini teman baru kalian, Yohana. Ia pindah dari Jayapura karena ayahnya bertugas di Bogor,” kata Bu Ratna. Yohana tersenyum malu-malu.\n\nSaat memperkenalkan diri, Yohana berbicara dengan logat Papua yang khas. Beberapa anak di barisan belakang tertawa, termasuk Dimas. Yohana langsung terdiam dan menunduk. Bu Ratna menatap mereka dan berkata, “Setiap daerah punya cara bicara yang berbeda. Itu kekayaan bangsa kita, bukan bahan tertawaan.” Kelas pun menjadi hening.\n\nPada jam istirahat, Yohana duduk sendirian di bangku taman. Nisa menghampirinya sambil membawa dua bungkus kue. “Boleh aku duduk di sini? Ini, untukmu,” kata Nisa. Mereka pun mengobrol. Nisa bertanya tentang Jayapura, dan Yohana bercerita tentang pantai dan papeda, makanan dari sagu yang biasa ia santap bersama keluarganya.\n\nSeminggu kemudian, ada tugas menampilkan lagu daerah pada pelajaran Seni Budaya. Nisa mengajak Yohana satu kelompok. “Kamu mau mengajari kami lagu dari Papua?” tanya Nisa. Yohana mengangguk dengan mata berbinar. Ia mengajarkan lagu “Yamko Rambe Yamko” kepada teman-teman kelompoknya.\n\nSaat kelompok mereka tampil, seluruh kelas bertepuk tangan dengan meriah. Setelah pelajaran usai, Dimas mendekati Yohana. “Yohana, maaf, ya, waktu itu aku menertawakanmu. Suaramu bagus sekali,” kata Dimas. Yohana tersenyum. “Tidak apa-apa. Kapan-kapan aku ajari kamu juga, ya.”"
    },
    {
      "id": "pf-pelita-kelasku",
      "jenis": "Teks Fiksi",
      "judul": "Pelita di Kelasku",
      "bentuk": "puisi",
      "teks": "Saat fajar baru menyapa,\nengkau sudah berdiri di depan kelas,\nmenyambut kami dengan senyum hangat,\nseperti mentari yang tak pernah lelah.\n\nEngkau pelita di kelasku,\nmenerangi kami yang belum tahu,\ndari mengeja huruf demi huruf,\nhingga kami pandai membaca dunia.\n\nKadang kami nakal dan membuatmu kesal,\ntetapi tak pernah kau balas dengan amarah,\nkau tuntun kami dengan sabar,\nseperti ibu menuntun langkah anaknya.\n\nTerima kasih, Guruku,\njasamu tak dapat kubalas dengan harta,\nakan kubalas dengan belajar sungguh-sungguh,\nagar kelak aku berguna bagi bangsa."
    }
  ],
  "soal": [
    {
      "id": "pf-estafet-01",
      "bacaan": "pf-tongkat-estafet",
      "topik": "alur-peristiwa",
      "tipe": "pg",
      "teks": "Mengapa tongkat estafet terjatuh saat Tiara memberikannya kepada Raka?",
      "pilihan": [
        {
          "teks": "Tiara sengaja menjatuhkan tongkat itu",
          "alasan": "Tidak ada bagian cerita yang menunjukkan Tiara sengaja. Tiara justru berlari **sekuat tenaga** menuju Raka."
        },
        {
          "teks": "Raka sudah berlari terlalu cepat sebelum tongkat sampai di tangannya",
          "alasan": "Paragraf ketiga menyebut Raka **sudah berlari terlalu cepat sebelum tongkat sampai di tangannya**, sehingga tongkat terlepas dan jatuh. Ini terjadi karena Raka tidak pernah berlatih memberi tongkat bersama timnya."
        },
        {
          "teks": "Tiara tersandung dan terjatuh saat berlari",
          "alasan": "Cerita tidak menyebut Tiara tersandung. Yang jatuh adalah tongkatnya, bukan Tiara."
        },
        {
          "teks": "Pelari 6A menyenggol tongkat itu",
          "alasan": "Pelari 6A baru melesat **setelah** tongkat jatuh, saat Raka berbalik mengambilnya. Ia tidak menyenggol tongkat."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Namun, Raka sudah berlari terlalu cepat sebelum tongkat sampai di tangannya. Tongkat itu terlepas dan jatuh ke tanah."
      ],
      "langkah": [
        {
          "teks": "Soal ini menanyakan **penyebab** sebuah peristiwa. Cari kalimat yang menceritakan tongkat jatuh, lalu baca kalimat tepat sebelumnya. Kata **namun** di paragraf ketiga menandai saat masalah terjadi."
        },
        {
          "tanya": {
            "soal": "Pada saat tongkat jatuh, siapa yang bergerak terlalu cepat?",
            "pilihan": [
              "Tiara",
              "Raka",
              "Bayu"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Raka sudah berlari sebelum tongkat sampai di tangannya, jadi tongkat itu terlepas."
        }
      ]
    },
    {
      "id": "pf-estafet-02",
      "bacaan": "pf-tongkat-estafet",
      "topik": "watak",
      "tipe": "pg",
      "teks": "Watak Raka pada awal cerita dapat digambarkan sebagai anak yang …",
      "pilihan": [
        {
          "teks": "Rendah hati dan senang berlatih bersama",
          "alasan": "Kebalikan dari cerita. Raka yakin timnya **pasti menang** dan **selalu menolak** ajakan berlatih bersama."
        },
        {
          "teks": "Malas dan tidak pernah berlatih",
          "alasan": "Raka tidak malas. Ia berlatih lari **sendirian setiap sore** selama seminggu. Masalahnya, ia tidak mau berlatih bersama tim."
        },
        {
          "teks": "Terlalu percaya diri dan tidak mau bekerja sama",
          "alasan": "Raka yakin timnya pasti menang dan berkata “Memberi tongkat itu gampang”, lalu selalu menolak berlatih bersama. Ucapan dan perbuatannya menunjukkan ia **terlalu percaya diri** dan **tidak mau bekerja sama**."
        },
        {
          "teks": "Penakut dan mudah menyerah",
          "alasan": "Tidak ada bukti Raka takut atau mudah menyerah. Ia justru sangat yakin akan menang."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Raka adalah pelari tercepat di kelas, dan ia yakin timnya pasti menang.",
        "Teman-temannya beberapa kali mengajaknya berlatih memberikan tongkat estafet bersama, tetapi Raka selalu menolak. “Yang penting larinya cepat. Memberi tongkat itu gampang,” katanya."
      ],
      "langkah": [
        {
          "teks": "Perhatikan kata **pada awal cerita**. Watak Raka berubah di akhir cerita, jadi lihat dulu ucapan dan perbuatannya di paragraf pertama dan kedua."
        },
        {
          "tanya": {
            "soal": "Apa yang dilakukan Raka setiap kali teman-temannya mengajak berlatih memberi tongkat?",
            "pilihan": [
              "Ikut berlatih",
              "Menolak",
              "Pura-pura sakit"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul, Raka selalu menolak. Ini menunjukkan ia tidak mau bekerja sama. Hati-hati: Raka tetap rajin berlatih lari, hanya saja sendirian."
        }
      ]
    },
    {
      "id": "pf-estafet-03",
      "bacaan": "pf-tongkat-estafet",
      "topik": "perasaan-tokoh",
      "tipe": "pg",
      "teks": "Kalimat “Tiara menunduk dan matanya berkaca-kaca” menunjukkan bahwa Tiara merasa …",
      "pilihan": [
        {
          "teks": "Sedih karena disalahkan atas kekalahan tim",
          "alasan": "Tiara menunduk dan matanya berkaca-kaca **tepat setelah** Raka berseru “Ini gara-gara Tiara!”. Mata berkaca-kaca adalah tanda hampir menangis karena sedih."
        },
        {
          "teks": "Senang karena timnya hampir menang",
          "alasan": "Timnya justru kalah, dan menunduk dengan mata berkaca-kaca bukan tanda senang."
        },
        {
          "teks": "Marah dan ingin membalas Raka",
          "alasan": "Orang yang marah biasanya membalas ucapan. Tiara justru diam dan menunduk."
        },
        {
          "teks": "Bangga dengan larinya yang cepat",
          "alasan": "Tidak ada tanda bangga. Menunduk biasanya menunjukkan sedih atau malu, bukan bangga."
        }
      ],
      "kunci": "A",
      "bukti": [
        "“Ini gara-gara Tiara!” serunya. Tiara menunduk dan matanya berkaca-kaca."
      ],
      "langkah": [
        {
          "teks": "Perasaan tokoh bisa dibaca dari **ekspresinya** dan dari **peristiwa sebelumnya**. Baca ucapan Raka tepat sebelum Tiara menunduk."
        },
        {
          "tanya": {
            "soal": "Mata yang berkaca-kaca biasanya tanda seseorang …",
            "pilihan": [
              "Hampir menangis",
              "Sedang tertawa",
              "Mengantuk"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Tiara hampir menangis karena Raka menyalahkannya, jadi ia merasa **sedih**."
        }
      ]
    },
    {
      "id": "pf-estafet-04",
      "bacaan": "pf-tongkat-estafet",
      "topik": "amanat",
      "tipe": "pg",
      "teks": "Amanat yang dapat dipetik dari cerita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Pelari tercepat sebaiknya selalu berlari di urutan terakhir",
          "alasan": "Ini hanya susunan tim dalam cerita, bukan pesan baik yang berlaku umum."
        },
        {
          "teks": "Kita harus selalu menang dalam setiap lomba",
          "alasan": "Cerita justru menunjukkan tim 6B kalah, lalu belajar dari kekalahan itu dan memberi selamat kepada pemenang. Pesannya bukan harus selalu menang."
        },
        {
          "teks": "Sebaiknya kita tidak ikut lomba agar tidak kecewa",
          "alasan": "Bertentangan dengan cerita. Tim 6B tidak berhenti, malah berlatih bersama setiap sore setelah kalah."
        },
        {
          "teks": "Kerja sama dan latihan bersama tim lebih penting daripada merasa paling hebat sendiri",
          "alasan": "Raka kalah karena merasa cukup cepat sendiri dan tidak mau berlatih bersama. Pak Darto menegaskan bahwa “estafet itu lomba tim”, dan akhirnya tim 6B selalu berlatih bersama. Inilah pesan baik cerita."
        }
      ],
      "kunci": "D",
      "bukti": [
        "“Raka, estafet itu lomba tim. Secepat apa pun kamu berlari, tongkatnya harus berpindah dengan baik.",
        "Sejak hari itu, tim 6B selalu berlatih bersama setiap sore."
      ],
      "langkah": [
        {
          "teks": "Amanat sering disampaikan lewat **nasihat tokoh dewasa** dan **perubahan sikap tokoh utama** di akhir cerita. Baca lagi ucapan Pak Darto dan apa yang dilakukan tim 6B sesudahnya."
        }
      ]
    },
    {
      "id": "pf-estafet-05",
      "bacaan": "pf-tongkat-estafet",
      "topik": "watak",
      "tipe": "mcma",
      "teks": "Sikap Raka di akhir cerita yang patut dicontoh adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Meminta maaf kepada Tiara",
          "benar": true,
          "alasan": "Raka menghampiri Tiara dan berkata “Maaf, Tiara.” Meminta maaf setelah berbuat salah patut dicontoh."
        },
        {
          "teks": "Mengakui kesalahannya sendiri",
          "benar": true,
          "alasan": "Raka berkata “Aku yang salah karena tidak mau berlatih bersama kalian.” Ia berani mengakui kesalahannya, tidak lagi menyalahkan orang lain."
        },
        {
          "teks": "Menendang rumput karena kesal",
          "benar": false,
          "alasan": "Ini terjadi tepat setelah kalah, sebelum Raka sadar. Menendang karena kesal bukan sikap yang patut dicontoh."
        },
        {
          "teks": "Ikut memberi selamat kepada tim yang menang",
          "benar": true,
          "alasan": "Mereka berempat, termasuk Raka, mendatangi tim 6A untuk **memberi selamat**. Ini sikap sportif."
        },
        {
          "teks": "Menyalahkan Tiara atas kekalahan tim",
          "benar": false,
          "alasan": "Raka memang sempat menyalahkan Tiara, tetapi itu sikap buruk dan ia kemudian meminta maaf atasnya."
        }
      ],
      "bukti": [
        "“Maaf, Tiara. Aku yang salah karena tidak mau berlatih bersama kalian,” katanya.",
        "Setelah itu, mereka berempat mendatangi tim 6A untuk memberi selamat."
      ],
      "langkah": [
        {
          "teks": "Perhatikan dua kata penting di soal: **di akhir cerita** dan **patut dicontoh**. Jadi, pilih hanya sikap baik yang dilakukan Raka setelah ia sadar, yaitu di paragraf terakhir."
        }
      ]
    },
    {
      "id": "pf-estafet-06",
      "bacaan": "pf-tongkat-estafet",
      "topik": "alur-peristiwa",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan cerita.",
      "pernyataan": [
        {
          "teks": "Raka berlatih lari sendirian setiap sore selama seminggu.",
          "benar": true,
          "alasan": "Benar. Paragraf kedua menyebut: selama seminggu, Raka berlatih lari **sendirian setiap sore**."
        },
        {
          "teks": "Tim 6B kalah karena Lestari terlambat memberikan tongkat kepada Bayu.",
          "benar": false,
          "alasan": "Salah. Lestari memberikan tongkat kepada Bayu **dengan lancar**. Masalah terjadi saat tongkat berpindah dari Tiara ke Raka."
        },
        {
          "teks": "Pak Darto mengingatkan Raka bahwa estafet adalah lomba tim.",
          "benar": true,
          "alasan": "Benar. Pak Darto berkata, “Raka, estafet itu lomba tim.”"
        },
        {
          "teks": "Tiara menolak memaafkan Raka.",
          "benar": false,
          "alasan": "Salah. Setelah Raka meminta maaf, Tiara **tersenyum dan mengangguk**, tanda ia memaafkan."
        }
      ],
      "bukti": [
        "Selama seminggu, Raka berlatih lari sendirian setiap sore.",
        "Lestari berlari paling awal dan memberikan tongkat kepada Bayu dengan lancar.",
        "Tiara tersenyum dan mengangguk."
      ],
      "langkah": [
        {
          "teks": "Periksa setiap pernyataan **satu per satu** dengan mencari bagian cerita yang membahasnya. Hati-hati dengan nama tokoh: apakah benar tokoh itu yang melakukannya?"
        }
      ]
    },
    {
      "id": "pf-opung-01",
      "bacaan": "pf-surat-opung",
      "topik": "latar",
      "tipe": "pg",
      "teks": "Latar tempat sebagian besar peristiwa dalam cerita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Lapangan bola tempat Ucok bermain",
          "alasan": "Lapangan hanya disebut saat Ucok berlari kembali ke sana. Tigor tidak pergi ke lapangan."
        },
        {
          "teks": "Pasar tempat Ibu berbelanja",
          "alasan": "Pasar hanya disebut sebagai tujuan Ibu. Tidak ada peristiwa yang diceritakan terjadi di pasar."
        },
        {
          "teks": "Rumah Tigor di Pematangsiantar",
          "alasan": "Kalimat pertama menyebut **rumah Tigor di Pematangsiantar**. Tigor menemani Opung, membacakan surat, dan menulis surat balasan, semuanya di rumah itu."
        },
        {
          "teks": "Sekolah Rosa di Jakarta",
          "alasan": "Sekolah Rosa hanya diceritakan di dalam surat. Peristiwa cerita tidak terjadi di Jakarta."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Hari Minggu siang, rumah Tigor di Pematangsiantar terasa sepi."
      ],
      "langkah": [
        {
          "teks": "Bedakan tempat yang **hanya disebut** dengan tempat **terjadinya peristiwa**. Tanyakan: di mana Tigor berada dari awal sampai akhir cerita?"
        },
        {
          "tanya": {
            "soal": "Di mana Tigor membacakan surat untuk Opung?",
            "pilihan": [
              "Di lapangan bola",
              "Di rumahnya",
              "Di pasar"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Hampir semua peristiwa terjadi di rumah Tigor di Pematangsiantar, jadi itulah latar tempat utamanya."
        }
      ]
    },
    {
      "id": "pf-opung-02",
      "bacaan": "pf-surat-opung",
      "topik": "alur-peristiwa",
      "tipe": "pg",
      "teks": "Apa yang dilakukan Tigor setelah menolak ajakan Ucok?",
      "pilihan": [
        {
          "teks": "Menyusul Ucok ke lapangan setelah Ibu pulang",
          "alasan": "Cerita tidak menyebut Tigor pergi ke lapangan. Ia merasa hari itu lebih menyenangkan daripada pertandingan bola mana pun."
        },
        {
          "teks": "Memperbaiki kacamata Opung yang patah",
          "alasan": "Kacamata Opung memang patah, tetapi cerita tidak menyebut Tigor memperbaikinya. Karena kacamata patah, Tigor yang membacakan surat."
        },
        {
          "teks": "Menulis surat untuk Ucok",
          "alasan": "Tigor memang membantu menulis surat, tetapi surat itu adalah **surat balasan untuk Rosa**, bukan untuk Ucok."
        },
        {
          "teks": "Membacakan surat dari Rosa untuk Opung",
          "alasan": "Paragraf kelima: Tigor duduk di samping Opung dan **membacakan surat itu dengan suara keras dan jelas**."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Tigor lalu duduk di samping Opung dan membacakan surat itu dengan suara keras dan jelas."
      ],
      "langkah": [
        {
          "teks": "Soal ini menanyakan **urutan peristiwa**. Temukan bagian Tigor menolak ajakan Ucok (paragraf 4), lalu baca peristiwa **sesudahnya**. Kata **lalu** di paragraf kelima menandai kejadian berikutnya."
        }
      ]
    },
    {
      "id": "pf-opung-03",
      "bacaan": "pf-surat-opung",
      "topik": "perasaan-tokoh",
      "tipe": "pg",
      "teks": "Opung berkata “Pergilah kalau mau bermain,” tetapi wajahnya tampak sedih. Hal ini menunjukkan bahwa Opung …",
      "pilihan": [
        {
          "teks": "Sebenarnya berharap Tigor tetap menemaninya membacakan surat",
          "alasan": "Opung menyebut ingin membaca surat Rosa tetapi kacamatanya patah, dan wajahnya **tampak sedih**. Ucapannya mempersilakan Tigor pergi, tetapi wajahnya menunjukkan ia sebenarnya membutuhkan bantuan Tigor."
        },
        {
          "teks": "Benar-benar ingin Tigor pergi bermain",
          "alasan": "Kalau benar-benar ingin Tigor pergi, wajah Opung tidak akan tampak sedih. Ia juga langsung menyebut masalahnya: tidak bisa membaca surat."
        },
        {
          "teks": "Marah kepada Tigor yang ingin bermain",
          "alasan": "Opung berbicara pelan dan tersenyum, tidak marah. Ia juga tidak menegur Tigor."
        },
        {
          "teks": "Tidak peduli pada surat dari Rosa",
          "alasan": "Kebalikan dari cerita. Opung memegang surat itu dan ingin sekali membacanya."
        }
      ],
      "kunci": "A",
      "bukti": [
        "“Opung hanya ingin membaca surat dari kakakmu, Rosa, di Jakarta. Tapi kacamata Opung patah tadi pagi.” Opung tersenyum, tetapi Tigor melihat wajah Opung tampak sedih."
      ],
      "langkah": [
        {
          "teks": "Kadang ucapan tokoh berbeda dengan perasaannya. Bandingkan **ucapan** Opung (“Pergilah kalau mau bermain”) dengan **wajahnya** (tampak sedih) dan **kalimat berikutnya** (kacamata patah, tidak bisa membaca surat)."
        },
        {
          "tanya": {
            "soal": "Mengapa Opung tidak bisa membaca surat Rosa sendiri?",
            "pilihan": [
              "Kacamatanya patah",
              "Suratnya hilang",
              "Opung tidak suka membaca"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Karena kacamatanya patah, Opung membutuhkan bantuan. Wajah sedihnya menunjukkan ia sebenarnya berharap Tigor tetap menemaninya."
        }
      ]
    },
    {
      "id": "pf-opung-04",
      "bacaan": "pf-surat-opung",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “bimbang” pada paragraf kedua memiliki makna yang paling dekat dengan …",
      "pilihan": [
        {
          "teks": "Gembira",
          "alasan": "Tigor sedang harus memilih antara bermain bola atau menemani Opung. Keadaan itu tidak membuatnya gembira."
        },
        {
          "teks": "Ragu-ragu",
          "alasan": "Tigor sudah berjanji bermain bola, tetapi juga dipesan Ibu menemani Opung. Saat Ucok memanggil, ia **ragu-ragu** memilih. Coba ganti: “Tigor ragu-ragu.” Kalimatnya tetap masuk akal."
        },
        {
          "teks": "Marah",
          "alasan": "Tidak ada tanda Tigor marah. Ia justru menolak ajakan Ucok dengan sopan."
        },
        {
          "teks": "Lelah",
          "alasan": "Tigor tidak sedang lelah. Kata “bimbang” muncul saat ia harus memilih antara dua hal."
        }
      ],
      "kunci": "B",
      "bukti": [
        "“Tigor! Ayo, kita kurang satu pemain!” Tigor bimbang."
      ],
      "langkah": [
        {
          "teks": "Untuk mencari makna kata, pikirkan **keadaan tokoh** saat kata itu muncul. Saat Ucok memanggil, Tigor punya dua pilihan: bermain bola bersama teman atau menemani Opung sesuai pesan Ibu."
        }
      ]
    },
    {
      "id": "pf-opung-05",
      "bacaan": "pf-surat-opung",
      "topik": "watak",
      "tipe": "mcma",
      "teks": "Watak Tigor yang tampak dalam cerita tersebut adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Bertanggung jawab menjalankan pesan Ibu",
          "benar": true,
          "alasan": "Tigor menolak ajakan Ucok karena “sudah janji kepada Ibu untuk menemani Opung”. Ia menjalankan tugas yang diberikan kepadanya."
        },
        {
          "teks": "Peduli pada perasaan Opung",
          "benar": true,
          "alasan": "Tigor memperhatikan wajah Opung yang tampak sedih, lalu memilih membacakan surat untuknya."
        },
        {
          "teks": "Mementingkan kesenangan sendiri",
          "benar": false,
          "alasan": "Kebalikan dari cerita. Tigor justru mengalahkan keinginannya bermain bola demi Opung."
        },
        {
          "teks": "Sopan saat menolak ajakan teman",
          "benar": true,
          "alasan": "Tigor mendatangi pagar, meminta maaf, dan menjelaskan alasannya kepada Ucok: “Cok, maaf, hari ini aku tidak bisa ikut.”"
        },
        {
          "teks": "Malas membantu orang tua",
          "benar": false,
          "alasan": "Tidak ada bukti Tigor malas. Ia membacakan surat dan bahkan membantu Opung menulis surat balasan."
        }
      ],
      "bukti": [
        "“Cok, maaf, hari ini aku tidak bisa ikut. Aku sudah janji kepada Ibu untuk menemani Opung,” katanya.",
        "Opung tersenyum, tetapi Tigor melihat wajah Opung tampak sedih."
      ],
      "langkah": [
        {
          "teks": "Untuk setiap watak, cari **perbuatan** atau **ucapan** Tigor yang menjadi buktinya. Watak yang tidak punya bukti di cerita jangan dipilih."
        },
        {
          "tanya": {
            "soal": "Mengapa Tigor menolak ajakan Ucok?",
            "pilihan": [
              "Ia sudah janji kepada Ibu menemani Opung",
              "Ia tidak suka bermain bola",
              "Ia sedang sakit"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Menepati pesan Ibu menunjukkan Tigor **bertanggung jawab**, dan cara ia menjelaskan kepada Ucok menunjukkan ia **sopan**."
        }
      ]
    },
    {
      "id": "pf-opung-06",
      "bacaan": "pf-surat-opung",
      "topik": "amanat",
      "tipe": "pg",
      "teks": "Amanat yang dapat dipetik dari cerita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Bermain bola tidak bermanfaat bagi anak-anak",
          "alasan": "Cerita tidak menyebut bermain bola itu buruk. Tigor hanya memilih tugas yang lebih penting pada hari itu."
        },
        {
          "teks": "Kita hendaknya menyayangi dan membantu orang yang lebih tua, walaupun harus mengalahkan keinginan sendiri",
          "alasan": "Tigor menunda keinginannya bermain bola untuk membantu Opung, dan ia justru merasa hari itu sangat menyenangkan. Ini pesan baik yang berlaku untuk semua pembaca."
        },
        {
          "teks": "Menulis surat lebih baik daripada menelepon",
          "alasan": "Cerita tidak membandingkan surat dengan telepon, jadi ini bukan pesan cerita."
        },
        {
          "teks": "Anak sebaiknya tidak berteman dengan tetangga",
          "alasan": "Tidak ada pesan seperti itu. Ucok tetap teman Tigor dan menerima alasan Tigor dengan baik."
        }
      ],
      "kunci": "B",
      "bukti": [
        "“Terima kasih, Tigor. Kau cucu yang baik,” ucapnya sambil mengusap kepala Tigor.",
        "Tigor merasa hari itu lebih menyenangkan daripada pertandingan bola mana pun."
      ],
      "langkah": [
        {
          "teks": "Amanat bisa dilihat dari **pilihan baik** tokoh dan **akibatnya**. Tigor memilih menemani Opung. Akibatnya, Opung bahagia, Ibu bangga, dan Tigor sendiri merasa senang."
        }
      ]
    },
    {
      "id": "pf-landak-01",
      "bacaan": "pf-liang-landak",
      "topik": "watak",
      "tipe": "pg",
      "teks": "Watak Cici pada awal cerita adalah …",
      "pilihan": [
        {
          "teks": "Lincah dan suka menolong hewan lain",
          "alasan": "Cici memang lincah, tetapi di awal cerita ia tidak suka menolong. Ia justru **mengejek** hewan lain."
        },
        {
          "teks": "Sombong dan suka mengejek hewan lain",
          "alasan": "Paragraf pertama menyebut Cici **suka menyombongkan diri dan mengejek hewan lain**. Buktinya, ia mengejek Lomo: “Jalanmu lambat sekali.”"
        },
        {
          "teks": "Pendiam dan pemalu",
          "alasan": "Cici bukan pendiam. Ia mengejek Lomo dengan suara keras sambil tertawa."
        },
        {
          "teks": "Lambat dan penyabar",
          "alasan": "Ini lebih cocok untuk Lomo, bukan Cici. Cici justru dapat melompat **secepat angin**."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Sayangnya, Cici suka menyombongkan diri dan mengejek hewan lain yang tidak secepat dirinya.",
        "“Hai, Lomo! Jalanmu lambat sekali."
      ],
      "langkah": [
        {
          "teks": "Kadang penulis langsung menyebutkan watak tokoh. Perhatikan kata **sayangnya** di paragraf pertama: kata itu menandai sifat buruk tokoh."
        }
      ]
    },
    {
      "id": "pf-landak-02",
      "bacaan": "pf-liang-landak",
      "topik": "alur-peristiwa",
      "tipe": "pg",
      "teks": "Mengapa Cici terlempar ke tanah dan kakinya terkilir?",
      "pilihan": [
        {
          "teks": "Cici dikejar musang yang lapar",
          "alasan": "Musang baru datang **malam itu**, setelah Cici berada di liang Lomo. Musang bukan penyebab Cici terlempar."
        },
        {
          "teks": "Cici melompat terlalu jauh saat pamer kepada Lomo",
          "alasan": "Cerita tidak menyebut Cici jatuh saat pamer. Ia terlempar ketika badai datang."
        },
        {
          "teks": "Lomo mendorong Cici dari dahan",
          "alasan": "Lomo tidak pernah mendorong Cici. Lomo justru menolong Cici."
        },
        {
          "teks": "Pohon tempat Cici bersarang patah dan roboh karena angin kencang dan hujan deras",
          "alasan": "Paragraf ketiga: angin bertiup sangat kencang dan hujan turun deras, lalu **pohon tempat Cici bersarang patah dan roboh**. Akibatnya, Cici terlempar ke tanah."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Angin bertiup sangat kencang dan hujan turun deras sepanjang malam. Pohon tempat Cici bersarang patah dan roboh. Cici terlempar ke tanah dengan kaki terkilir."
      ],
      "langkah": [
        {
          "teks": "Cari kalimat **Cici terlempar ke tanah**, lalu baca kalimat sebelumnya. Peristiwa sebelumnya adalah penyebabnya."
        },
        {
          "tanya": {
            "soal": "Apa yang terjadi pada pohon tempat Cici bersarang?",
            "pilihan": [
              "Ditebang",
              "Patah dan roboh",
              "Terbakar"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Pohonnya patah dan roboh diterjang angin kencang dan hujan deras, sehingga Cici terlempar."
        }
      ]
    },
    {
      "id": "pf-landak-03",
      "bacaan": "pf-liang-landak",
      "topik": "perasaan-tokoh",
      "tipe": "pg",
      "teks": "Cici terkejut ketika Lomo menawarkan liangnya. Mengapa Cici terkejut?",
      "pilihan": [
        {
          "teks": "Cici ingat pernah mengejek Lomo, tetapi Lomo tetap mau menolongnya",
          "alasan": "Tepat setelah kata “terkejut”, cerita menyebut Cici **teringat ejekannya kepada Lomo**. Ia tidak menyangka hewan yang pernah ia ejek justru menolongnya."
        },
        {
          "teks": "Cici takut tertusuk duri Lomo",
          "alasan": "Cerita tidak menyebut Cici takut pada duri Lomo saat itu. Alasan terkejutnya dijelaskan di kalimat berikutnya: ia teringat ejekannya."
        },
        {
          "teks": "Cici mengira suara itu suara musang",
          "alasan": "Lomo memanggil nama Cici dengan jelas. Musang baru datang setelah Cici masuk ke liang."
        },
        {
          "teks": "Cici tidak mengenal Lomo sama sekali",
          "alasan": "Cici mengenal Lomo. Beberapa hari sebelumnya ia mengejek Lomo dan memanggil namanya."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Cici terkejut. Ia teringat ejekannya kepada Lomo beberapa hari sebelumnya."
      ],
      "langkah": [
        {
          "teks": "Penulis sering menjelaskan perasaan tokoh di **kalimat sesudahnya**. Baca kalimat tepat setelah “Cici terkejut.”"
        }
      ]
    },
    {
      "id": "pf-landak-04",
      "bacaan": "pf-liang-landak",
      "topik": "alur-peristiwa",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan cerita.",
      "pernyataan": [
        {
          "teks": "Lomo membalas ejekan Cici dengan marah.",
          "benar": false,
          "alasan": "Salah. Cerita menyebut Lomo **tidak membalas**. Ia hanya tersenyum dan melanjutkan perjalanannya."
        },
        {
          "teks": "Hujan deras turun sepanjang malam.",
          "benar": true,
          "alasan": "Benar. Paragraf ketiga menyebut hujan turun deras **sepanjang malam**."
        },
        {
          "teks": "Duri Lomo membuat musang lari ketakutan.",
          "benar": true,
          "alasan": "Benar. Lomo menegakkan duri-durinya, lalu musang tertusuk duri dan lari ketakutan."
        },
        {
          "teks": "Di akhir cerita, Cici masih suka mengejek hewan lain.",
          "benar": false,
          "alasan": "Salah. Kalimat terakhir: sejak saat itu, Cici **tidak pernah lagi** mengejek hewan lain."
        }
      ],
      "bukti": [
        "Lomo tidak membalas. Ia hanya tersenyum dan melanjutkan perjalanannya.",
        "Musang itu tertusuk duri dan lari ketakutan.",
        "Sejak saat itu, Cici tidak pernah lagi mengejek hewan lain."
      ],
      "langkah": [
        {
          "teks": "Cocokkan setiap pernyataan dengan cerita. Perhatikan kata kecil yang bisa mengubah makna, seperti **masih**, **tidak**, dan **dengan marah**."
        }
      ]
    },
    {
      "id": "pf-landak-05",
      "bacaan": "pf-liang-landak",
      "topik": "watak",
      "tipe": "mcma",
      "teks": "Watak Lomo yang tampak dalam cerita tersebut adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Sabar ketika diejek",
          "benar": true,
          "alasan": "Saat diejek Cici, Lomo **tidak membalas** dan hanya tersenyum."
        },
        {
          "teks": "Suka menolong walaupun pernah disakiti",
          "benar": true,
          "alasan": "Lomo menawarkan liangnya kepada Cici yang beberapa hari sebelumnya mengejeknya."
        },
        {
          "teks": "Pendendam",
          "benar": false,
          "alasan": "Orang pendendam akan membalas perbuatan buruk. Lomo justru menolong Cici."
        },
        {
          "teks": "Sombong karena memiliki duri",
          "benar": false,
          "alasan": "Lomo tidak pernah menyombongkan durinya. Ia malah berkata setiap makhluk punya kelebihan masing-masing."
        },
        {
          "teks": "Melindungi temannya dari bahaya",
          "benar": true,
          "alasan": "Lomo segera menegakkan duri-durinya di mulut liang sehingga musang lari dan Cici selamat."
        }
      ],
      "bukti": [
        "Lomo tidak membalas. Ia hanya tersenyum dan melanjutkan perjalanannya.",
        "“Cici, masuklah ke liangku. Di dalam tanah lebih hangat dan kering,” kata Lomo.",
        "Lomo segera menegakkan duri-durinya di mulut liang."
      ],
      "langkah": [
        {
          "teks": "Ikuti perbuatan Lomo dari awal sampai akhir: saat diejek, saat Cici kena musibah, dan saat musang datang. Setiap perbuatan menunjukkan satu watak."
        },
        {
          "tanya": {
            "soal": "Apa yang dilakukan Lomo saat diejek Cici?",
            "pilihan": [
              "Membalas mengejek",
              "Tersenyum dan tidak membalas",
              "Menusuk Cici dengan duri"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Tidak membalas ejekan menunjukkan Lomo **sabar**. Sekarang periksa juga apa yang ia lakukan saat badai dan saat musang datang."
        }
      ]
    },
    {
      "id": "pf-landak-06",
      "bacaan": "pf-liang-landak",
      "topik": "amanat",
      "tipe": "pg",
      "teks": "Amanat yang dapat dipetik dari fabel tersebut adalah …",
      "pilihan": [
        {
          "teks": "Tupai sebaiknya tidak bersarang di pohon",
          "alasan": "Ini hanya kejadian dalam cerita, bukan pesan baik untuk pembaca."
        },
        {
          "teks": "Kita harus pandai melompat agar selamat dari bahaya",
          "alasan": "Kelincahan Cici justru tidak menolongnya saat badai. Yang menolong adalah kebaikan dan duri Lomo."
        },
        {
          "teks": "Jangan meremehkan orang lain karena setiap makhluk punya kelebihan masing-masing",
          "alasan": "Cici meremehkan duri Lomo, padahal duri itu yang menyelamatkan mereka. Lomo pun berkata, “Setiap makhluk punya kelebihan masing-masing.”"
        },
        {
          "teks": "Hewan berduri berbahaya dan harus dijauhi",
          "alasan": "Bertentangan dengan cerita. Lomo yang berduri justru baik hati dan menolong."
        }
      ],
      "kunci": "C",
      "bukti": [
        "“Lomo, maafkan aku. Dulu aku mengejek durimu, padahal durimu yang menyelamatkan kita,” katanya.",
        "“Setiap makhluk punya kelebihan masing-masing, Cici.”"
      ],
      "langkah": [
        {
          "teks": "Fabel adalah cerita hewan yang mengandung pesan untuk **manusia**. Amanatnya sering diucapkan tokoh di akhir cerita. Baca ucapan Lomo di paragraf terakhir."
        },
        {
          "tanya": {
            "soal": "Apa yang dulu diejek Cici, tetapi akhirnya menyelamatkan mereka?",
            "pilihan": [
              "Kaki Lomo",
              "Duri Lomo",
              "Liang Lomo"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Hal yang dulu diremehkan ternyata berguna. Jadi, pesannya: jangan meremehkan orang lain."
        }
      ]
    },
    {
      "id": "pf-yohana-01",
      "bacaan": "pf-lagu-dari-timur",
      "topik": "tokoh",
      "tipe": "pg",
      "teks": "Siapa tokoh yang menegur anak-anak yang menertawakan Yohana?",
      "pilihan": [
        {
          "teks": "Nisa",
          "alasan": "Nisa baru muncul pada jam istirahat, saat ia menghampiri Yohana. Ia tidak menegur anak-anak di kelas."
        },
        {
          "teks": "Dimas",
          "alasan": "Dimas justru termasuk anak yang **tertawa**, bukan yang menegur."
        },
        {
          "teks": "Bu Ratna",
          "alasan": "Bu Ratna menatap anak-anak yang tertawa dan berkata, “Itu kekayaan bangsa kita, bukan bahan tertawaan.”"
        },
        {
          "teks": "Ayah Yohana",
          "alasan": "Ayah Yohana hanya disebut sebagai alasan Yohana pindah. Ia tidak berada di kelas."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Bu Ratna menatap mereka dan berkata, “Setiap daerah punya cara bicara yang berbeda. Itu kekayaan bangsa kita, bukan bahan tertawaan.”"
      ],
      "langkah": [
        {
          "teks": "Cari bagian cerita saat anak-anak tertawa (paragraf kedua), lalu lihat **siapa yang berbicara** sesudahnya."
        }
      ]
    },
    {
      "id": "pf-yohana-02",
      "bacaan": "pf-lagu-dari-timur",
      "topik": "perasaan-tokoh",
      "tipe": "pg",
      "teks": "Kalimat “Yohana langsung terdiam dan menunduk” menunjukkan bahwa Yohana merasa …",
      "pilihan": [
        {
          "teks": "Senang karena mendapat banyak perhatian",
          "alasan": "Orang yang senang tidak akan langsung terdiam dan menunduk. Perhatian yang ia dapat adalah tertawaan."
        },
        {
          "teks": "Malu dan sedih karena logatnya ditertawakan",
          "alasan": "Yohana terdiam dan menunduk **tepat setelah** beberapa anak menertawakan logatnya. Menunduk adalah tanda malu atau sedih."
        },
        {
          "teks": "Marah dan ingin membalas Dimas",
          "alasan": "Yohana tidak membalas apa pun. Di akhir cerita ia bahkan memaafkan Dimas."
        },
        {
          "teks": "Mengantuk karena perjalanan jauh",
          "alasan": "Cerita tidak menyebut Yohana mengantuk. Ia terdiam karena ditertawakan."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Beberapa anak di barisan belakang tertawa, termasuk Dimas. Yohana langsung terdiam dan menunduk."
      ],
      "langkah": [
        {
          "teks": "Perhatikan peristiwa **tepat sebelum** Yohana terdiam. Peristiwa itulah penyebab perasaannya."
        },
        {
          "tanya": {
            "soal": "Apa yang dilakukan beberapa anak saat Yohana memperkenalkan diri?",
            "pilihan": [
              "Bertepuk tangan",
              "Tertawa",
              "Bertanya tentang Papua"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Yohana ditertawakan, jadi ia merasa **malu dan sedih**."
        }
      ]
    },
    {
      "id": "pf-yohana-03",
      "bacaan": "pf-lagu-dari-timur",
      "topik": "watak",
      "tipe": "pg",
      "teks": "Berdasarkan perbuatannya, Nisa adalah anak yang …",
      "pilihan": [
        {
          "teks": "Pemalu dan penakut",
          "alasan": "Nisa tidak pemalu. Ia lebih dulu menghampiri Yohana dan mengajaknya mengobrol."
        },
        {
          "teks": "Suka pamer makanan",
          "alasan": "Nisa membawa kue bukan untuk pamer, melainkan untuk **diberikan** kepada Yohana: “Ini, untukmu.”"
        },
        {
          "teks": "Suka menertawakan teman",
          "alasan": "Nisa tidak disebut ikut tertawa. Yang tertawa adalah beberapa anak di barisan belakang, termasuk Dimas."
        },
        {
          "teks": "Ramah dan peduli kepada teman baru",
          "alasan": "Nisa menghampiri Yohana yang duduk sendirian, memberinya kue, menanyakan kampung halamannya, dan mengajaknya satu kelompok. Semua itu tanda anak yang **ramah** dan **peduli**."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Nisa menghampirinya sambil membawa dua bungkus kue. “Boleh aku duduk di sini? Ini, untukmu,” kata Nisa.",
        "Nisa mengajak Yohana satu kelompok."
      ],
      "langkah": [
        {
          "teks": "Kumpulkan semua **perbuatan Nisa** di paragraf ketiga dan keempat. Watak yang benar harus cocok dengan semua perbuatan itu."
        },
        {
          "tanya": {
            "soal": "Untuk siapa kue yang dibawa Nisa?",
            "pilihan": [
              "Untuk dimakan sendiri",
              "Untuk Yohana",
              "Untuk dijual"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Nisa berbagi kue dengan teman baru yang sedang sendirian. Itu tanda ia **ramah dan peduli**, bukan pamer."
        }
      ]
    },
    {
      "id": "pf-yohana-04",
      "bacaan": "pf-lagu-dari-timur",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “logat” pada paragraf kedua bermakna …",
      "pilihan": [
        {
          "teks": "Cara mengucapkan kata yang khas dari suatu daerah",
          "alasan": "Bu Ratna menjelaskan bahwa **setiap daerah punya cara bicara yang berbeda**. Jadi, logat Papua adalah cara bicara yang khas dari Papua."
        },
        {
          "teks": "Suara yang sangat keras",
          "alasan": "Logat bukan soal keras atau pelan, tetapi soal cara pengucapan yang khas suatu daerah."
        },
        {
          "teks": "Bahasa asing dari luar negeri",
          "alasan": "Yohana berasal dari Jayapura, Indonesia, dan berbicara bahasa Indonesia dengan logat Papua, bukan bahasa asing."
        },
        {
          "teks": "Nyanyian dari suatu daerah",
          "alasan": "Nyanyian daerah disebut lagu daerah, seperti “Yamko Rambe Yamko” di paragraf keempat. Logat berhubungan dengan cara berbicara."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Saat memperkenalkan diri, Yohana berbicara dengan logat Papua yang khas.",
        "“Setiap daerah punya cara bicara yang berbeda."
      ],
      "langkah": [
        {
          "teks": "Cari petunjuk makna di kalimat sekitarnya. Ucapan Bu Ratna di paragraf yang sama menjelaskan apa yang ditertawakan anak-anak."
        },
        {
          "tanya": {
            "soal": "Menurut Bu Ratna, setiap daerah punya … yang berbeda.",
            "pilihan": [
              "Cara bicara",
              "Lagu kebangsaan",
              "Warna seragam"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Jadi, logat adalah **cara bicara** atau cara mengucapkan kata yang khas dari suatu daerah."
        }
      ]
    },
    {
      "id": "pf-yohana-05",
      "bacaan": "pf-lagu-dari-timur",
      "topik": "watak",
      "tipe": "mcma",
      "teks": "Sikap menghargai perbedaan (toleransi) yang tampak dalam cerita adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Bu Ratna mengingatkan bahwa cara bicara daerah bukan bahan tertawaan",
          "benar": true,
          "alasan": "Bu Ratna menyebut perbedaan cara bicara sebagai **kekayaan bangsa**. Ini sikap menghargai perbedaan."
        },
        {
          "teks": "Nisa bertanya tentang Jayapura dan mendengarkan cerita Yohana",
          "benar": true,
          "alasan": "Nisa ingin tahu tentang daerah asal Yohana. Mau mengenal budaya teman adalah sikap toleransi."
        },
        {
          "teks": "Beberapa anak menertawakan logat Yohana",
          "benar": false,
          "alasan": "Menertawakan logat orang lain justru **tidak** menghargai perbedaan."
        },
        {
          "teks": "Teman-teman belajar lagu dari Papua bersama Yohana",
          "benar": true,
          "alasan": "Kelompok Nisa mau belajar lagu “Yamko Rambe Yamko” dari Yohana. Mereka menghargai budaya daerah lain."
        },
        {
          "teks": "Yohana duduk sendirian di bangku taman",
          "benar": false,
          "alasan": "Ini hanya keadaan Yohana saat istirahat, bukan sikap menghargai perbedaan."
        }
      ],
      "bukti": [
        "Itu kekayaan bangsa kita, bukan bahan tertawaan.",
        "Nisa bertanya tentang Jayapura, dan Yohana bercerita tentang pantai dan papeda",
        "Ia mengajarkan lagu “Yamko Rambe Yamko” kepada teman-teman kelompoknya."
      ],
      "langkah": [
        {
          "teks": "Toleransi berarti **menghargai perbedaan**, misalnya perbedaan cara bicara, makanan, atau lagu daerah. Periksa setiap pilihan: apakah perbuatan itu menghargai perbedaan atau justru meremehkannya?"
        }
      ]
    },
    {
      "id": "pf-yohana-06",
      "bacaan": "pf-lagu-dari-timur",
      "topik": "alur-peristiwa",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan cerita.",
      "pernyataan": [
        {
          "teks": "Papeda adalah makanan dari sagu yang biasa disantap Yohana bersama keluarganya.",
          "benar": true,
          "alasan": "Benar. Paragraf ketiga menyebut papeda sebagai **makanan dari sagu** yang biasa Yohana santap bersama keluarganya."
        },
        {
          "teks": "Dimas tetap menertawakan Yohana sampai akhir cerita.",
          "benar": false,
          "alasan": "Salah. Di akhir cerita, Dimas **meminta maaf** dan memuji suara Yohana."
        },
        {
          "teks": "Yohana memaafkan Dimas.",
          "benar": true,
          "alasan": "Benar. Yohana tersenyum dan berkata, “Tidak apa-apa,” bahkan menawarkan diri mengajari Dimas."
        },
        {
          "teks": "Yohana mengajarkan lagu dari Jawa Barat kepada kelompoknya.",
          "benar": false,
          "alasan": "Salah. Yohana mengajarkan lagu dari **Papua**, yaitu “Yamko Rambe Yamko”."
        }
      ],
      "bukti": [
        "Yohana bercerita tentang pantai dan papeda, makanan dari sagu yang biasa ia santap bersama keluarganya.",
        "“Yohana, maaf, ya, waktu itu aku menertawakanmu. Suaramu bagus sekali,” kata Dimas. Yohana tersenyum. “Tidak apa-apa. Kapan-kapan aku ajari kamu juga, ya.”"
      ],
      "langkah": [
        {
          "teks": "Untuk setiap pernyataan, cari kata kuncinya di cerita (papeda, Dimas, lagu), lalu bandingkan isinya. Jangan menebak dari pengetahuanmu sendiri; gunakan isi cerita."
        }
      ]
    },
    {
      "id": "pf-pelita-01",
      "bacaan": "pf-pelita-kelasku",
      "topik": "tema",
      "tipe": "pg",
      "teks": "Tema puisi “Pelita di Kelasku” adalah …",
      "pilihan": [
        {
          "teks": "Keindahan matahari pagi",
          "alasan": "Mentari hanya dipakai sebagai **perbandingan** untuk senyum guru di bait pertama. Puisi tidak membahas keindahan matahari."
        },
        {
          "teks": "Jasa dan kesabaran seorang guru",
          "alasan": "Seluruh bait membicarakan guru: menyambut murid (bait 1), memberi ilmu (bait 2), menuntun dengan sabar (bait 3), dan jasanya yang tak terbalas harta (bait 4)."
        },
        {
          "teks": "Kenakalan murid di kelas",
          "alasan": "Kenakalan murid hanya disebut sekilas di bait ketiga untuk menunjukkan kesabaran guru. Itu bukan ide pokok seluruh puisi."
        },
        {
          "teks": "Kasih sayang seorang ibu kepada anaknya",
          "alasan": "Ibu hanya dipakai sebagai perbandingan: guru menuntun murid **seperti** ibu menuntun anaknya. Yang dibicarakan tetap guru."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Terima kasih, Guruku, jasamu tak dapat kubalas dengan harta,"
      ],
      "langkah": [
        {
          "teks": "Tema adalah hal yang dibicarakan **dari bait pertama sampai bait terakhir**. Hati-hati dengan kata yang hanya menjadi perbandingan, misalnya setelah kata **seperti**."
        },
        {
          "tanya": {
            "soal": "Siapa yang disapa “engkau” dan “Guruku” dalam puisi ini?",
            "pilihan": [
              "Matahari",
              "Ibu",
              "Guru"
            ],
            "jawaban": "C"
          },
          "setelah": "Betul. Seluruh puisi ditujukan kepada guru, jadi temanya tentang **jasa dan kesabaran guru**."
        }
      ]
    },
    {
      "id": "pf-pelita-02",
      "bacaan": "pf-pelita-kelasku",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Larik “Engkau pelita di kelasku” pada bait kedua bermakna …",
      "pilihan": [
        {
          "teks": "Guru selalu membawa lampu ke dalam kelas",
          "alasan": "Ini makna harfiah yang tidak cocok. Pelita di sini adalah **kiasan**, bukan lampu sungguhan."
        },
        {
          "teks": "Kelas menjadi gelap karena listrik padam",
          "alasan": "Puisi tidak membicarakan listrik atau keadaan kelas yang gelap."
        },
        {
          "teks": "Guru seperti penerang yang memberi ilmu kepada murid",
          "alasan": "Larik berikutnya menjelaskan: **menerangi kami yang belum tahu**. Pelita menerangi kegelapan, seperti guru menghilangkan ketidaktahuan murid dengan ilmu."
        },
        {
          "teks": "Guru menyalakan api setiap pagi",
          "alasan": "Ini makna harfiah yang tidak sesuai dengan isi puisi. Puisi berbicara tentang guru yang mengajar, bukan menyalakan api."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Engkau pelita di kelasku, menerangi kami yang belum tahu,"
      ],
      "langkah": [
        {
          "teks": "Dalam puisi, banyak kata bermakna **kiasan**, bukan makna sebenarnya. Pelita adalah lampu kecil yang menerangi gelap. Baca larik sesudahnya untuk tahu apa yang \"diterangi\" guru."
        }
      ]
    },
    {
      "id": "pf-pelita-03",
      "bacaan": "pf-pelita-kelasku",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Ungkapan “pandai membaca dunia” pada bait kedua berarti …",
      "pilihan": [
        {
          "teks": "Mampu memahami banyak hal tentang kehidupan berkat ilmu",
          "alasan": "Bait kedua menceritakan perjalanan belajar dari mengeja huruf demi huruf hingga \"membaca dunia\". Membaca dunia adalah kiasan untuk **memahami banyak hal** di sekitar kita."
        },
        {
          "teks": "Pandai membaca peta dunia",
          "alasan": "Peta tidak disebut di puisi. Ungkapan itu kiasan, bukan tentang membaca peta."
        },
        {
          "teks": "Pernah berkeliling ke seluruh dunia",
          "alasan": "Puisi tidak menceritakan perjalanan keliling dunia. Yang diceritakan adalah belajar di kelas."
        },
        {
          "teks": "Bisa membaca buku berbahasa asing",
          "alasan": "Bahasa asing tidak disebut di puisi."
        }
      ],
      "kunci": "A",
      "bukti": [
        "dari mengeja huruf demi huruf, hingga kami pandai membaca dunia."
      ],
      "langkah": [
        {
          "teks": "Perhatikan urutan dalam bait kedua: **dari** mengeja huruf **hingga** membaca dunia. Ini menggambarkan murid yang awalnya belum tahu apa-apa, lalu menjadi paham banyak hal."
        },
        {
          "tanya": {
            "soal": "Mengeja huruf demi huruf menggambarkan murid yang …",
            "pilihan": [
              "Baru mulai belajar",
              "Sudah sangat pintar"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Jadi, \"membaca dunia\" adalah kebalikannya: murid yang sudah memahami banyak hal berkat ilmu dari guru."
        }
      ]
    },
    {
      "id": "pf-pelita-04",
      "bacaan": "pf-pelita-kelasku",
      "topik": "perasaan-tokoh",
      "tipe": "pg",
      "teks": "Perasaan “aku” dalam bait keempat adalah …",
      "pilihan": [
        {
          "teks": "Kecewa kepada guru",
          "alasan": "Bait keempat diawali **terima kasih**. Tidak ada tanda kecewa."
        },
        {
          "teks": "Takut dimarahi guru",
          "alasan": "Bait ketiga justru menyebut guru **tak pernah** membalas dengan amarah. Tidak ada rasa takut."
        },
        {
          "teks": "Sedih karena akan berpisah dengan guru",
          "alasan": "Perpisahan tidak disebut di puisi. Jangan menambahkan hal yang tidak ada di teks."
        },
        {
          "teks": "Berterima kasih dan bertekad belajar sungguh-sungguh",
          "alasan": "Bait keempat berisi ucapan **terima kasih** dan tekad **akan kubalas dengan belajar sungguh-sungguh**."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Terima kasih, Guruku,",
        "akan kubalas dengan belajar sungguh-sungguh, agar kelak aku berguna bagi bangsa."
      ],
      "langkah": [
        {
          "teks": "Perasaan dalam puisi bisa dilihat dari **kata-kata yang dipilih penyair**. Baca larik pertama dan ketiga bait keempat."
        }
      ]
    },
    {
      "id": "pf-pelita-05",
      "bacaan": "pf-pelita-kelasku",
      "topik": "watak",
      "tipe": "mcma",
      "teks": "Sifat guru yang digambarkan dalam puisi tersebut adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Sabar",
          "benar": true,
          "alasan": "Bait ketiga: walaupun murid nakal, guru **tak pernah** membalas dengan amarah dan **menuntun dengan sabar**."
        },
        {
          "teks": "Rajin dan datang lebih awal",
          "benar": true,
          "alasan": "Bait pertama: **saat fajar baru menyapa**, guru sudah berdiri di depan kelas menyambut murid."
        },
        {
          "teks": "Ramah dan penyayang",
          "benar": true,
          "alasan": "Guru menyambut murid **dengan senyum hangat** dan menuntun mereka **seperti ibu menuntun langkah anaknya**."
        },
        {
          "teks": "Mudah marah",
          "benar": false,
          "alasan": "Bertentangan dengan bait ketiga: guru **tak pernah** membalas kenakalan murid dengan amarah."
        },
        {
          "teks": "Pelit berbagi ilmu",
          "benar": false,
          "alasan": "Bertentangan dengan bait kedua. Guru justru menerangi murid yang belum tahu sampai mereka pandai."
        }
      ],
      "bukti": [
        "Saat fajar baru menyapa, engkau sudah berdiri di depan kelas, menyambut kami dengan senyum hangat,",
        "tetapi tak pernah kau balas dengan amarah, kau tuntun kami dengan sabar, seperti ibu menuntun langkah anaknya."
      ],
      "langkah": [
        {
          "teks": "Periksa **setiap bait** satu per satu. Setiap bait menggambarkan sifat guru yang berbeda: bait 1 tentang cara guru menyambut, bait 3 tentang cara guru menghadapi murid yang nakal."
        }
      ]
    },
    {
      "id": "pf-pelita-06",
      "bacaan": "pf-pelita-kelasku",
      "topik": "amanat",
      "tipe": "pg",
      "teks": "Amanat yang terkandung dalam puisi tersebut adalah …",
      "pilihan": [
        {
          "teks": "Jasa guru harus dibalas dengan memberi hadiah yang mahal",
          "alasan": "Bertentangan dengan bait keempat: jasa guru **tak dapat kubalas dengan harta**."
        },
        {
          "teks": "Murid boleh nakal karena guru pasti sabar",
          "alasan": "Puisi tidak membolehkan murid nakal. Kenakalan disebut untuk menunjukkan kesabaran guru, dan \"aku\" justru bertekad belajar sungguh-sungguh."
        },
        {
          "teks": "Kita hendaknya menghormati guru dan membalas jasanya dengan belajar sungguh-sungguh",
          "alasan": "Bait keempat berisi pesan ini: jasa guru dibalas **dengan belajar sungguh-sungguh** agar kelak berguna bagi bangsa."
        },
        {
          "teks": "Kita harus datang ke sekolah sebelum fajar",
          "alasan": "Yang datang saat fajar adalah guru, dan itu menggambarkan kerajinannya. Ini bukan pesan untuk pembaca."
        }
      ],
      "kunci": "C",
      "bukti": [
        "jasamu tak dapat kubalas dengan harta, akan kubalas dengan belajar sungguh-sungguh, agar kelak aku berguna bagi bangsa."
      ],
      "langkah": [
        {
          "teks": "Amanat puisi sering ada di **bait terakhir**, tempat penyair menyampaikan tekad atau harapannya. Baca bait keempat dengan teliti."
        },
        {
          "tanya": {
            "soal": "Dengan apa \"aku\" akan membalas jasa guru?",
            "pilihan": [
              "Dengan harta",
              "Dengan belajar sungguh-sungguh",
              "Dengan datang sebelum fajar"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Pesan inilah amanatnya: hormati guru dan balas jasanya dengan belajar sungguh-sungguh."
        }
      ]
    }
  ]
}
